/* eslint-disable react/no-did-update-set-state */
/* eslint-disable import/no-unresolved */
import { Field, Form, withFormik } from "formik";
import moment from "moment";
import { arrayOf, bool, func, number, shape, string } from "prop-types";
import React, { Component } from "react";
import Col from "react-bootstrap/lib/Col";
import Row from "react-bootstrap/lib/Row";
import { connect } from "react-redux";
import { push } from "react-router-redux/actions";
import { compose } from "redux";
import Yup from "yup";

import { selectors as accountsSelectors } from "reducers/accounts";
import { actions as multilineFileActions } from "reducers/formFields/multilineFile";
import { selectors as sessionSelectors } from "reducers/session";
import { actions as statusActions } from "reducers/status";
import { actions as thirdPaymentActions, selectors as thirdPaymentSelector } from "reducers/thirdPayment";
import { actions as transactionsActions } from "reducers/transactions";

import * as configUtils from "util/config";
import * as i18n from "util/i18n";
import { retailStatuses, statuses } from "util/thirdPayment";

import classNames from "classnames";
import Button from "pages/_components/Button";
import Container from "pages/_components/Container";
import ContextMenu from "pages/_components/ContextMenu";
import DownloadButton from "pages/_components/DownloadButton";
import { DateField } from "pages/_components/fields/DateField";
import AmountField from "pages/_components/fields/formik/AmountField";
import Selector from "pages/_components/fields/formik/Selector";
import RangeDatePicker from "pages/_components/fields/rangedatepicker/RangeDatePicker";
import Head from "pages/_components/Head";
import I18n from "pages/_components/I18n";
import Image from "pages/_components/Image";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import PageLoading from "pages/_components/PageLoading";
import Pagination from "pages/_components/pagination/Pagination";
import { resizableRoute } from "pages/_components/Resizable";
import { evalEqualsValues } from "util/form";
import { applyEmbeddedV3ShellLayoutState, clearEmbeddedV3ShellLayoutState } from "util/v3ShellLayoutSync";
import TransactionThirdPaymentTable from "./_components/TransactionThirdPaymentTable";

const FORM_ID = "payments.payThirdParties";

class PayThirdPartiesList extends Component {
    state = {
        selectedDateFrom: null,
        isSupplierPayments: true,
        showForm: false,
        showSnackbarFiltered: false,
        hasChanged: false,
    };

    static propTypes = {
        dispatch: func.isRequired,
        values: shape({}).isRequired,
        status: string.isRequired,
        isDesktop: bool.isRequired,
        isSmallDesktop: bool.isRequired,
        handleSubmit: func.isRequired,
        requests: arrayOf(shape({})).isRequired,
        latestPageNumber: number.isRequired,
        latestTotalPages: number.isRequired,
        fetching: bool.isRequired,
        isFirstFetching: bool.isRequired,
        activeEnvironment: shape({
            permissions: shape({
                newThirdPayment: bool,
            }),
        }).isRequired,
        fetchingDownload: bool.isRequired,
        setFieldValue: func.isRequired,
        filters: shape({}).isRequired,
        filtersBack: shape({}).isRequired,
        location: shape({}).isRequired,
        typeLabel: string.isRequired,
        isValid: bool.isRequired,
        amountFrom: number.isRequired,
        amountTo: number.isRequired,
        dateFrom: string.isRequired,
        dateTo: string.isRequired,
        embeddedInV3Shell: bool,
    };

    static defaultProps = {
        embeddedInV3Shell: false,
    };

    componentDidMount() {
        const {
            dispatch,
            filters: { amountFrom, amountTo, dateFrom, dateTo },
            filtersBack,
            setFieldValue,
            latestPageNumber,
            latestTotalPages,
            location,
            filters,
        } = this.props;
        this.setState({ hasChanged: false });
        dispatch(transactionsActions.saveTransactionRoute(location?.pathname));
        if (location) {
            dispatch(statusActions.saveLastHref(location));
        }
        const typePayment = this.paymentSelected();
        const enableRangeDatefield = configUtils.getBoolean("frontend.show.RangeDatePicker.functionalities", false);

        if (filtersBack) {
            setFieldValue("status", filtersBack?.values?.status || "ALL");
            setFieldValue(
                "dateFrom",
                filtersBack?.values?.dateFrom ||
                    moment()
                        .subtract(6, "months")
                        .toDate(),
            );
            setFieldValue(
                "dateTo",
                filtersBack?.values?.dateTo ||
                    moment()
                        .add(1, "days")
                        .toDate(),
            );
            setFieldValue("dates", [
                filtersBack?.values?.dates
                    ? filtersBack?.values?.dates[0]
                    : moment()
                          .subtract(6, "months")
                          .add(1, "days")
                          .toDate(),
                filtersBack?.values?.dates
                    ? filtersBack?.values?.dates[1]
                    : moment()
                          .add(1, "days")
                          .toDate(),
            ]);
            setFieldValue("amountFrom", filtersBack?.values?.amountFrom || "");
            setFieldValue("amountTo", filtersBack?.values?.amountTo || "");

            if (filtersBack?.values) {
                this.setState({ hasChanged: false });
            }
            if (filtersBack.typeL === "PP") {
                this.setState({
                    isSupplierPayments: true,
                });
                dispatch(thirdPaymentActions.setTypeSU());
            } else {
                this.setState({
                    isSupplierPayments: false,
                });
                dispatch(thirdPaymentActions.setTypeH());
            }

            dispatch(
                thirdPaymentActions.loadListThirdRequest({
                    dateFrom:
                        enableRangeDatefield && filtersBack?.values?.dates
                            ? filtersBack?.values?.dates[0]
                            : filtersBack?.values?.dateFrom ||
                              moment()
                                  .subtract(6, "months")
                                  .add(1, "days")
                                  .format("YYYY-MM-DD"),
                    dateTo:
                        enableRangeDatefield && filtersBack?.values?.dates
                            ? filtersBack?.values?.dates[1]
                            : filtersBack?.values?.dateTo ||
                              moment()
                                  .add(1, "days")
                                  .format("YYYY-MM-DD"),
                    amountFrom: filtersBack?.values?.amountFrom || "",
                    amountTo: filtersBack?.values?.amountTo || "",
                    status: filtersBack?.values?.status || "ALL",
                    typePayment: filtersBack?.typeL ?? filtersBack?.tipo,
                    latestPageNumber,
                    latestTotalPages,
                    isFirstFetching: true,
                }),
            );
        } else {
            if (!dateTo && !dateFrom) {
                if (enableRangeDatefield) {
                    setFieldValue("dates", [
                        moment()
                            .subtract(6, "months")
                            .add(1, "days")
                            .toDate(),
                        moment()
                            .add(1, "days")
                            .toDate(),
                    ]);
                } else {
                    setFieldValue(
                        "dateFrom",
                        moment()
                            .subtract(6, "months")
                            .toDate(),
                    );
                    setFieldValue("dateTo", moment().toDate());
                }
            } else if (enableRangeDatefield) {
                setFieldValue("dates", [
                    moment()
                        .subtract(6, "months")
                        .add(1, "days")
                        .toDate(),
                    moment()
                        .add(1, "days")
                        .toDate(),
                ]);
            }
            dispatch(
                thirdPaymentActions.loadListThirdRequest({
                    dateFrom:
                        dateFrom ||
                        moment()
                            .subtract(6, "months")
                            .add(1, "days")
                            .format("YYYY-MM-DD"),
                    dateTo:
                        dateTo ||
                        moment()
                            .add(1, "days")
                            .format("YYYY-MM-DD"),
                    amountFrom,
                    amountTo,
                    status: filters.status,
                    typePayment,
                    latestPageNumber: "1",
                    latestTotalPages: "1",
                    isFirstFetching: true,
                }),
            );
        }
        this.syncEmbeddedV3ShellLayout();
    }

    componentDidUpdate(prevProps) {
        const { embeddedInV3Shell, isDesktop, activeEnvironment } = this.props;
        const permissionsChanged = prevProps.activeEnvironment?.permissions !== activeEnvironment?.permissions;
        if (
            embeddedInV3Shell &&
            (prevProps.embeddedInV3Shell !== embeddedInV3Shell ||
                prevProps.isDesktop !== isDesktop ||
                permissionsChanged)
        ) {
            this.syncEmbeddedV3ShellLayout();
        }
    }

    componentWillUnmount() {
        const { embeddedInV3Shell, dispatch } = this.props;
        if (embeddedInV3Shell) {
            clearEmbeddedV3ShellLayoutState(dispatch);
        }
    }

    syncEmbeddedV3ShellLayout = () => {
        const { dispatch, embeddedInV3Shell, isDesktop } = this.props;
        applyEmbeddedV3ShellLayoutState(dispatch, {
            embeddedInV3Shell,
            isDesktop,
            scopes: ["forms"],
            titleKey: "payments.payThirdParties.title",
            goBackPath: "/v3/dashboard",
            rightContentMobile: !isDesktop ? this.getMobilePayThirdPartiesShellMenu() : undefined,
        });
    };

    getMobilePayThirdPartiesShellMenu = () => {
        const { isDesktop, activeEnvironment } = this.props;
        const items = [];
        if (activeEnvironment.permissions.newThirdPayment) {
            items.push({
                label: "payments.payThirdParties.newpayment.button",
                onClick: () => this.handleClickNewPayment(),
                icon: "PayService",
            });
        }
        items.push({
            label: "payments.payThirdParties.download.button",
            onClick: () => this.handleDownloadClick("pdf"),
            icon: "SendDown",
        });
        return (
            <ContextMenu
                isDesktop={isDesktop}
                color={!isDesktop ? "white" : "neutral"}
                buttonClassName="align-self-center account-dropdown-header-font font-black-alpha ml-2"
                items={items}
            />
        );
    };

    paymentSelected = () => {
        const { isSupplierPayments } = this.state;
        if (!isSupplierPayments) {
            return "PH";
        }
        return "PP";
    };

    handleBack = () => {
        const { dispatch, embeddedInV3Shell } = this.props;
        if (embeddedInV3Shell) {
            dispatch(push("/v3/dashboard"));
            return;
        }
        dispatch(push("/desktop/"));
    };

    handleDownloadClick = (format) => {
        const { dispatch, requests, filtersBack } = this.props;
        requests.forEach((request) => {
            delete request.transaction.fullDescription;
        });
        const enableRangeDatefield = configUtils.getBoolean("frontend.show.RangeDatePicker.functionalities", false);

        const filters = {
            ...filtersBack?.values,
            ...(enableRangeDatefield && {
                dateFrom: filtersBack?.values?.dates && filtersBack?.values?.dates[0],
                dateTo: filtersBack?.values?.dates && filtersBack?.values?.dates[1],
            }),
            typePayment: this.paymentSelected(),
        };

        dispatch(thirdPaymentActions.downloadListThirdPayment(format, requests, filters));
    };

    handleClickNewPayment = () => {
        const { dispatch } = this.props;
        dispatch(thirdPaymentActions.clearData());
        dispatch(thirdPaymentActions.setSummaryNewThirdPayment({}));
        dispatch(multilineFileActions.onFileRemoved());
        if (configUtils.getBoolean("frontend.multilinePayments.new.uploader.component", true)) {
            dispatch(push("/v2/payThirdParties/newPayment"));
        } else {
            dispatch(push("newPayment"));
        }
    };

    rightContent = () => {
        const { isDesktop, isSmallDesktop, activeEnvironment, fetchingDownload } = this.props;
        const items = [];
        if (activeEnvironment.permissions.newThirdPayment) {
            items.push({
                label: "payments.payThirdParties.newpayment.button",
                onClick: () => this.handleClickNewPayment(),
                icon: "PayService",
            });
        }
        items.push({
            label: "payments.payThirdParties.download.button",
            onClick: () => this.handleDownloadClick("pdf"),
            icon: "SendDown",
        });

        if (isDesktop && !isSmallDesktop) {
            return (
                <>
                    {activeEnvironment.permissions.newThirdPayment ? (
                        <Button
                            block={false}
                            onClick={() => this.handleClickNewPayment()}
                            label="payments.payThirdParties.newpayment.button"
                            bsStyle="primary"
                            className="cmf-button-width"
                        />
                    ) : (
                        undefined
                    )}
                    <DownloadButton
                        fetching={fetchingDownload}
                        handleClick={this.handleDownloadClick}
                        handleClickMessage="global.download"
                        csvDownload
                        xlsDownload
                        imageStyle="mr-2"
                    />
                </>
            );
        }

        return (
            <ContextMenu
                isDesktop={isDesktop}
                color={!isDesktop ? "white" : "neutral"}
                buttonClassName="align-self-center account-dropdown-header-font font-black-alpha ml-2"
                items={items}
            />
        );
    };

    renderEmptyState = () => {};

    handleChangeDateFrom = (selectedDate) => {
        this.setState({ selectedDateFrom: selectedDate });
    };

    changeOption = (option) => {
        const { dispatch, amountFrom, amountTo, dateFrom, dateTo, status, setFieldValue } = this.props;
        const enableRangeDatefield = configUtils.getBoolean("frontend.show.RangeDatePicker.functionalities", false);
        if (!dateTo && !dateFrom) {
            if (enableRangeDatefield) {
                setFieldValue("dates", [
                    moment()
                        .subtract(6, "months")
                        .add(1, "days")
                        .toDate(),
                    moment()
                        .add(1, "days")
                        .toDate(),
                ]);
            } else {
                setFieldValue(
                    "dateFrom",
                    moment()
                        .subtract(6, "months")
                        .toDate(),
                );
                setFieldValue("dateTo", moment().toDate());
            }
        }
        setFieldValue("status", "ALL");
        setFieldValue("amountFrom", "");
        setFieldValue("amountTo", "");
        const { hasChanged } = this.state;
        if (hasChanged) {
            this.setState({ hasChanged: false });
        }

        const values = { amountFrom, amountTo, dateFrom, dateTo, status };
        if (option === "supplier") {
            this.setState({
                isSupplierPayments: true,
            });
            dispatch(thirdPaymentActions.setTypeSU());
            dispatch(thirdPaymentActions.setFiltersBack({ values, typeL: "PP" }));

            dispatch(
                thirdPaymentActions.loadListThirdRequest({
                    dateFrom:
                        dateFrom ||
                        moment()
                            .subtract(6, "months")
                            .add(1, "days")
                            .format("YYYY-MM-DD"),
                    dateTo:
                        dateTo ||
                        moment()
                            .add(1, "days")
                            .format("YYYY-MM-DD"),
                    amountFrom: amountFrom || "",
                    amountTo: amountTo || "",
                    status: status || "ALL",
                    typePayment: "PP",
                    latestPageNumber: "1",
                    latestTotalPages: "1",
                    isFirstFetching: true,
                }),
            );
        } else {
            this.setState({
                isSupplierPayments: false,
            });
            dispatch(thirdPaymentActions.setTypeH());
            dispatch(thirdPaymentActions.setFiltersBack({ values, typeL: "PH" }));
            dispatch(thirdPaymentActions.setFiltersBack({ values, showForm: false }));
            dispatch(thirdPaymentActions.setFiltersBack({ values, tipo: "PH" }));
            dispatch(
                thirdPaymentActions.loadListThirdRequest({
                    dateFrom:
                        dateFrom ||
                        moment()
                            .subtract(6, "months")
                            .add(1, "days")
                            .format("YYYY-MM-DD"),
                    dateTo:
                        dateTo ||
                        moment()
                            .add(1, "days")
                            .format("YYYY-MM-DD"),
                    amountFrom: amountFrom || "",
                    amountTo: amountTo || "",
                    status: status || "ALL",
                    typePayment: "PH",
                    latestPageNumber: "1",
                    latestTotalPages: "1",
                    isFirstFetching: true,
                }),
            );
        }
    };

    renderCloseButton = () => (
        <button
            type="button"
            className="btn-link mt-1"
            aria-label="Close"
            onClick={() => this.setState({ showSnackbarFiltered: false })}>
            <Image src="images/cross-mobile-blue.svg" styles={{ width: "20px", height: "20px" }} />
        </button>
    );

    renderHeader = () => {
        const { isDesktop } = this.props;
        const { showSnackbarFiltered } = this.state;
        const hideSnack = false;

        if (isDesktop) {
            return (
                <>
                    <Head onBack={this.handleBack} />
                    <Head
                        title="payments.payThirdParties.title"
                        handleClickMessage="global.download"
                        rightContent={() => this.rightContent()}
                    />
                </>
            );
        }

        return (
            <>
                <Head
                    headerClassName="blue-main-header-mobile"
                    titleClassName="w-100 align-center"
                    onBack={this.handleBack}
                    title="payments.payThirdParties.title"
                    rightContent={() => this.rightContent()}
                />

                {!isDesktop && hideSnack && showSnackbarFiltered && (
                    <Container className="thirdPaymentList hint-snackbar-mobile filted py-4">
                        <Col xs={12}>
                            <Col xs={10} className="justify-content-center text-align-center mt-2">
                                <span>{i18n.get("echeq.filter.active")}</span>
                            </Col>
                            <Col xs={2}>{this.renderCloseButton()}</Col>
                        </Col>
                    </Container>
                )}
            </>
        );
    };

    getDateFilter = () => {
        const { dateFrom, dateTo, isDesktop, isSmallDesktop, values } = this.props;
        const { selectedDateFrom } = this.state;
        const enableRangeDatefield = configUtils.getBoolean("frontend.show.RangeDatePicker.functionalities", false);
        const formName = isDesktop || enableRangeDatefield ? FORM_ID : `${FORM_ID}.mobile`;

        const dateFromField = () => (
            <Field
                idField="dateFrom"
                component={DateField}
                idForm={formName}
                name="dateFrom"
                hidePlaceholder
                selectsStart
                startDate={new Date()}
                endDate={dateTo}
                handleChange={this.handleChangeDateFrom}
                handleCustomChange={(value, form) => {
                    form.setFieldValue("dateFrom", value);
                }}
                autoComplete="off"
                errorClassName="p-absolute"
                value={values?.dateFrom}
                controlLabelClassName="input__required"
            />
        );

        const dateToField = () => (
            <Field
                idField="dateTo"
                component={DateField}
                hidePlaceholder
                idForm={formName}
                name="dateTo"
                selectsEnd
                startDate={dateFrom}
                endDate={dateTo}
                minDate={selectedDateFrom}
                handleCustomChange={(value, form) => {
                    form.setFieldValue("dateTo", value);
                }}
                autoComplete="off"
                errorClassName="p-absolute"
                value={values?.dateTo}
                controlLabelClassName="input__required"
            />
        );
        if (enableRangeDatefield) {
            return (
                <Col xs={12} md={6} lg={3} className="mt-1 px-1 mb-35">
                    <Field
                        name="dates"
                        component={RangeDatePicker}
                        idForm={formName}
                        minDate={moment()
                            .add(-6, "months")
                            .toDate()}
                        value={values?.dates}
                        required
                    />
                </Col>
            );
        }

        if (isDesktop) {
            return (
                <>
                    <Col xs={12} lg={isSmallDesktop ? 4 : 2} md={6} className="px-1">
                        {dateFromField()}
                    </Col>
                    <Col xs={12} lg={isSmallDesktop ? 4 : 2} md={6} className="px-1">
                        {dateToField()}
                    </Col>
                </>
            );
        }

        const labelTitleDate = `${FORM_ID}.mobile.date.label`;
        return (
            <>
                <Col xs={12} className="px-4">
                    <Row className="justify-content-left">
                        <I18n id={labelTitleDate} />
                    </Row>
                </Col>

                <Col xs={12} className="px-2">
                    <Col xs={6} className="pl-0">
                        {dateFromField()}
                    </Col>
                    <Col xs={6} className="pr-0">
                        {dateToField()}
                    </Col>
                </Col>
            </>
        );
    };

    getAmountFilter = () => {
        const { isDesktop, isSmallDesktop } = this.props;

        const amountFromField = () => (
            <Field
                idForm={FORM_ID}
                component={AmountField}
                name="amountFrom"
                formGroupClassName="my-0"
                clearable={false}
                maxLength={17}
                isFocused
                plainValue
                hideCurrency
                hidePlaceholder
                fixedDecimalScale
            />
        );

        const amountToField = () => (
            <Field
                idForm={FORM_ID}
                component={AmountField}
                name="amountTo"
                formGroupClassName="my-0"
                clearable={false}
                maxLength={17}
                isFocused
                plainValue
                hideCurrency
                hidePlaceholder
                fixedDecimalScale
            />
        );

        if (isDesktop) {
            return (
                <>
                    <Col lg={isSmallDesktop ? 4 : 2} md={6} xs={12} className="px-1">
                        {amountFromField()}
                    </Col>
                    <Col lg={isSmallDesktop ? 4 : 2} md={6} xs={12} className="px-1">
                        {amountToField()}
                    </Col>
                </>
            );
        }
        return (
            <>
                <Col xs={6} className="px-1">
                    {amountFromField()}
                </Col>
                <Col xs={6} className="px-1">
                    {amountToField()}
                </Col>
            </>
        );
    };

    fetchNextTransactions = (pageNumber) => {
        const {
            dispatch,
            amountFrom,
            amountTo,
            dateFrom,
            dateTo,
            latestTotalPages,
            values: { status },
        } = this.props;
        const typePayment = this.paymentSelected();
        dispatch(
            thirdPaymentActions.loadListThirdRequest({
                dateFrom,
                dateTo,
                amountFrom,
                amountTo,
                status,
                typePayment,
                pageNumber,
                latestTotalPages,
                isFirstFetching: false,
            }),
        );
    };

    fetchMoreTransactions = () => {
        const { dispatch, latestTotalPages, latestPageNumber, values } = this.props;
        const typePayment = this.paymentSelected();
        const { amountFrom, amountTo, dateFrom, dateTo, status } = values;

        dispatch(
            thirdPaymentActions.loadMoreListThirdRequest({
                dateFrom,
                dateTo,
                amountFrom,
                amountTo,
                status,
                typePayment,
                pageNumber: latestPageNumber + 1,
                latestTotalPages,
            }),
        );
    };

    chargeListByScheme = () => {
        const { activeEnvironment } = this.props;

        if (activeEnvironment?.administrationScheme === "simple") {
            return [...retailStatuses];
        }

        return [...statuses];
    };

    clearFilters = () => {
        const { setFieldValue, dispatch, typeLabel } = this.props;
        let typeL;
        if (typeLabel) {
            typeL = "PP";
        } else {
            typeL = "PH";
        }
        setFieldValue("status", "ALL");
        setFieldValue(
            "dateFrom",
            moment()
                .subtract(6, "months")
                .toDate(),
        );
        setFieldValue("dateTo", moment().toDate());
        setFieldValue("dates", [
            moment()
                .subtract(6, "months")
                .add(1, "days")
                .toDate(),
            moment()
                .add(1, "days")
                .toDate(),
        ]);
        setFieldValue("amountFrom", "");
        setFieldValue("amountTo", "");

        this.setState((prevState) => ({ ...prevState, hasChanged: false }));

        dispatch(thirdPaymentActions.setFiltersBack());

        dispatch(
            thirdPaymentActions.loadListThirdRequest({
                dateFrom: moment()
                    .subtract(6, "months")
                    .add(1, "days")
                    .format("YYYY-MM-DD"),
                dateTo: moment()
                    .add(1, "days")
                    .format("YYYY-MM-DD"),
                dates: [
                    moment()
                        .subtract(6, "months")
                        .add(1, "days")
                        .format("YYYY-MM-DD"),
                    moment()
                        .add(1, "days")
                        .format("YYYY-MM-DD"),
                ],
                amountFrom: "",
                amountTo: "",
                status: "ALL",
                typePayment: typeL,
                latestPageNumber: "1",
                latestTotalPages: "1",
            }),
        );
    };

    handleFilterButton = () => {
        const { values } = this.props;
        const enableRangeDatefield = configUtils.getBoolean("frontend.show.RangeDatePicker.functionalities", false);

        const usingDefaultValues = evalEqualsValues(
            {
                status: "ALL",
                dateFrom: moment()
                    .subtract(6, "months")
                    .add(1, "days")
                    .toDate(),
                dateTo: moment(new Date()).add(1, "days"),
                amountFrom: "",
                amountTo: "",
            },
            values,
            [...(!enableRangeDatefield ? ["dates"] : []), ...(enableRangeDatefield ? ["dateFrom", "dateTo"] : [])],
            [...(enableRangeDatefield ? ["dates"] : []), ...(!enableRangeDatefield ? ["dateFrom", "dateTo"] : [])],
        );

        this.setState((prevState) => ({ ...prevState, hasChanged: !usingDefaultValues }));
    };

    render() {
        const {
            values,
            isDesktop,
            isSmallDesktop,
            handleSubmit,
            latestPageNumber,
            latestTotalPages,
            fetching,
            requests,
            isFirstFetching,
            filters,
            isValid,
            embeddedInV3Shell,
        } = this.props;

        const { isSupplierPayments, showForm } = this.state;
        const defaultOption = { value: "ALL", label: "TODOS" };
        const { hasChanged } = this.state;
        const enableRangeDatefield = configUtils.getBoolean("frontend.show.RangeDatePicker.functionalities", false);
        const enableNewSubmitButton = configUtils.getBoolean("frontend.Show.FilterButton.Functionalities", false);

        const statusList = this.chargeListByScheme();
        let lgCols = 2;
        if (enableRangeDatefield) {
            lgCols = 3;
        } else if (isSmallDesktop) {
            lgCols = 4;
        }
        return (
            <>
                {!embeddedInV3Shell && <Notification scopeToShow="forms" />}
                {(!embeddedInV3Shell || isDesktop) && (
                    <div className="admin-detail-head w-100 px-0 mb-0">{this.renderHeader()}</div>
                )}
                <Form
                    className={classNames("w-100", { "mt-3": isDesktop }, { payment__form_v2: enableRangeDatefield })}
                    onSubmit={async (e) => {
                        await handleSubmit(e);
                        if (isValid) {
                            this.handleFilterButton();
                            this.setState((prev) => ({
                                ...prev,
                                showForm: prev.showForm,
                                showSnackbarFiltered: !prev.showSnackbarFiltered,
                            }));
                        }
                    }}>
                    <Container className="container-white py-3 align-items-center">
                        <Col xs={12} className="d-flex justify-content-start align-item-center w-100">
                            <div className="d-flex align-item-center w-100">
                                <Button
                                    className="btn-outline btn-regular chip-selector-btn"
                                    block={false}
                                    image={isSupplierPayments ? "images/check.svg" : ""}
                                    style={{
                                        backgroundColor: isSupplierPayments ? "#f2f8fd" : "",
                                        borderColor: isSupplierPayments ? "#0071ce" : "#ccc",
                                        color: isSupplierPayments ? "#0071ce" : "#666",
                                    }}
                                    onClick={() => this.changeOption("supplier")}
                                    label="payments.payThirdParties.newPayment.supplierPayments.label"
                                />
                                <Button
                                    className="btn-outline btn-regular chip-selector-btn"
                                    block={false}
                                    name="salary"
                                    image={!isSupplierPayments ? "images/check.svg" : ""}
                                    style={{
                                        backgroundColor: !isSupplierPayments ? "#f2f8fd" : "",
                                        borderColor: !isSupplierPayments ? "#0071ce" : "#ccc",
                                        color: !isSupplierPayments ? "#0071ce" : "#666",
                                    }}
                                    onClick={() => this.changeOption("salary")}
                                    label="payments.payThirdParties.newPayment.salaryPayments.label"
                                />
                            </div>
                            {isDesktop && (
                                <div className="hide-filter__btn-content mr-3">
                                    <Button
                                        block
                                        bsStyle="outline"
                                        className="hide-filter__btn m-0"
                                        label={
                                            showForm
                                                ? "global.hide.filter"
                                                : `${hasChanged ? "global.filter.active" : "global.see.filter"}`
                                        }
                                        image={showForm ? "images/eye-off.svg" : "images/eye.svg"}
                                        onClick={() => this.setState((prev) => ({ ...prev, showForm: !prev.showForm }))}
                                    />
                                    {hasChanged && (
                                        <Button
                                            label="echeq.clean.filters"
                                            className="hide-filter__clean-btn"
                                            onClick={() => this.clearFilters()}
                                            image="images/cross.svg"
                                            imageStyle="circle-cross"
                                        />
                                    )}
                                </div>
                            )}
                        </Col>
                    </Container>
                    {!isDesktop && (
                        <Col xs={12} className="d-flex justify-content-end pr-0 py-3">
                            <div className="hide-filter__btn-content">
                                <Button
                                    block
                                    bsStyle="outline"
                                    className="hide-filter__btn m-0"
                                    label={
                                        showForm
                                            ? "global.hide.filter"
                                            : `${hasChanged ? "global.filter.active" : "global.see.filter"}`
                                    }
                                    image={showForm ? "images/eye-off.svg" : "images/eye.svg"}
                                    onClick={() => this.setState((prev) => ({ ...prev, showForm: !prev.showForm }))}
                                />
                            </div>
                            {hasChanged && (
                                <Button
                                    label="global.clean.filters"
                                    className="clean-filters-label font-light p-absolute top-25 mt-2 pt-1 min-height-auto mr-4 "
                                    onClick={() => this.clearFilters()}
                                    image="images/cross.svg"
                                    imageStyle="circle-cross"
                                />
                            )}
                        </Col>
                    )}
                    {showForm && (
                        <div className={`flex-grow mt-4 ${isDesktop ? "container-white pt-3 mb-0 pb-0 px-3" : "px-2"}`}>
                            <Col xs={12} md={12} lg={lgCols} className="px-1">
                                <Field
                                    component={Selector}
                                    options={[defaultOption, ...statusList]}
                                    idForm={FORM_ID}
                                    name="status"
                                    isRequired
                                    value={values?.status || defaultOption}
                                    style={{ paddingTop: "12px", paddingBottom: "12px" }}
                                    className="ellipsis-text"
                                    searchable={isDesktop}
                                />
                            </Col>

                            {this.getDateFilter()}

                            {this.getAmountFilter()}

                            <Col
                                lg={isSmallDesktop ? 4 : 2}
                                md={6}
                                xs={12}
                                className="px-1 align-self-flex-start mt-28">
                                <div className="form-group mb-2">
                                    <Button
                                        label="payments.payThirdParties.button.filter"
                                        bsStyle="primary"
                                        type="submit"
                                        loading={fetching}
                                        image={enableNewSubmitButton ? "filter-icon.svg" : undefined}
                                        imageStyle="mr-2"
                                        className={classNames({
                                            "text-transform-none": enableNewSubmitButton,
                                        })}
                                        disabled={
                                            enableNewSubmitButton &&
                                            evalEqualsValues(
                                                filters,
                                                values,
                                                [
                                                    ...(!enableRangeDatefield ? ["dates"] : []),
                                                    ...(enableRangeDatefield ? ["dateFrom", "dateTo"] : []),
                                                ],
                                                [
                                                    ...(enableRangeDatefield ? ["dates"] : []),
                                                    ...(!enableRangeDatefield ? ["dateFrom", "dateTo"] : []),
                                                ],
                                            )
                                        }
                                    />
                                </div>
                            </Col>
                        </div>
                    )}
                </Form>

                {isDesktop ? (
                    <PageLoading className="line-loader" loading={fetching}>
                        <MainContainer
                            className={`debin w-100 ${isDesktop && "overflow-hidden"}`}
                            showLoader={false}
                            showChildrenWithLoader>
                            <div>
                                <TransactionThirdPaymentTable
                                    fetching={fetching}
                                    requests={requests}
                                    isDesktop={isDesktop}
                                    option={isSupplierPayments}
                                />
                                <div className="d-flex w-100 justify-content-end ">
                                    <Pagination
                                        totalPages={latestTotalPages}
                                        pageNumber={latestPageNumber}
                                        action={this.fetchNextTransactions}
                                    />
                                </div>
                            </div>
                        </MainContainer>
                    </PageLoading>
                ) : (
                    <MainContainer showLoader={isFirstFetching} showChildrenWithLoader>
                        <div className="above-the-fold">
                            <TransactionThirdPaymentTable
                                requests={requests}
                                latestPageNumber={latestPageNumber}
                                latestTotalPages={latestTotalPages}
                                isDesktop={isDesktop}
                                option={isSupplierPayments}
                                fetchMoreTransactions={this.fetchMoreTransactions}
                            />
                        </div>
                    </MainContainer>
                )}
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    loggedUser: sessionSelectors.getUser(state),
    transaction: thirdPaymentSelector.getTransaction(state),
    accounts: accountsSelectors.getAccounts(state),
    typeLabel: thirdPaymentSelector.getTypeSelect(state),
    requests: thirdPaymentSelector.getTransactionLinesStatus(state),
    latestPageNumber: thirdPaymentSelector.getLatestPageNumber(state),
    latestTotalPages: thirdPaymentSelector.getLatestTotalPages(state),
    fetching: thirdPaymentSelector.getFetching(state),
    isFirstFetching: thirdPaymentSelector.isFirstFetching(state),
    activeEnvironment: sessionSelectors.getActiveEnvironment(state),
    fetchingDownload: thirdPaymentSelector.getFetchingDownload(state),
    filtersBack: thirdPaymentSelector.getFiltersBack(state),
    filters: {
        dateFrom: thirdPaymentSelector.getDateFrom(state),
        dateTo: thirdPaymentSelector.getDateTo(state),
        amountFrom: thirdPaymentSelector.getAmountFrom(state),
        amountTo: thirdPaymentSelector.getAmountTo(state),
        status: thirdPaymentSelector.getStatus(state),
    },
});

export default compose(
    connect(mapStateToProps),
    withFormik({
        validateOnChange: true,
        validateOnBlur: false,
        mapPropsToValues: (props) => ({
            dateFrom: props.isDesktop
                ? null
                : moment()
                      .subtract(6, "months")
                      .add(1, "days"),
            dateTo: props.isDesktop ? null : moment(new Date()).add(1, "days"),
            amountFrom: "",
            amountTo: "",
        }),
        validationSchema: () => {
            const enableRangeDatefield = configUtils.getBoolean("frontend.show.RangeDatePicker.functionalities", false);
            return Yup.lazy((values) =>
                Yup.object().shape({
                    ...(!enableRangeDatefield && {
                        dateFrom: values.dateTo
                            ? Yup.date()
                                  .nullable()
                                  .required(i18n.get(`${FORM_ID}.validation.range.date`))
                                  .max(values.dateTo, i18n.get(`${FORM_ID}.dateFrom.error`))
                            : Yup.date()
                                  .nullable()
                                  .required(i18n.get(`${FORM_ID}.validation.range.date`)),
                        dateTo: values.dateFrom
                            ? Yup.date()
                                  .nullable()
                                  .required(i18n.get(`${FORM_ID}.validation.range.date`))
                                  .min(values.dateFrom, i18n.get(`${FORM_ID}.dateTo.error`))
                            : Yup.date()
                                  .nullable()
                                  .required(i18n.get(`${FORM_ID}.validation.range.date`)),
                    }),
                    amountFrom: values.amountTo
                        ? Yup.number()
                              .typeError(i18n.get(`${FORM_ID}.amount.amountFrom.required`))
                              .required(i18n.get(`${FORM_ID}.amount.amountFrom.required`))
                              .max(values.amountTo, i18n.get(`${FORM_ID}.amount.amountFrom.error`))
                        : Yup.string().nullable(),
                    amountTo: values.amountFrom
                        ? Yup.number()
                              .typeError(i18n.get(`${FORM_ID}.amount.amountTo.required`))
                              .required(i18n.get(`${FORM_ID}.amount.amountTo.required`))
                              .min(values.amountFrom, i18n.get(`${FORM_ID}.amount.amountTo.error`))
                        : Yup.string().nullable(),
                    ...(enableRangeDatefield && {
                        dates: Yup.mixed().test(
                            "dates",
                            i18n.get(`${FORM_ID}.validation.range.date`),
                            ([from, to]) => from && to,
                        ),
                    }),
                }),
            );
        },
        handleSubmit: (values, formikBag) => {
            const { dispatch, typeLabel } = formikBag.props;
            const { setValues } = formikBag;
            let typeL;
            const { amountFrom, amountTo, dateFrom, dateTo, dates, status } = values;
            const enableRangeDatefield = configUtils.getBoolean("frontend.show.RangeDatePicker.functionalities", false);

            if (typeLabel) {
                typeL = "PP";
            } else {
                typeL = "PH";
            }

            const valuesFiltersBack = { values, typeL };
            let dFrom = null;
            if (enableRangeDatefield) {
                setValues({
                    ...values,
                    ...(dates[0] && !dates[1] && { dates: [null, null] }),
                });
                if (dates[1]) {
                    dFrom = dates?.[0];
                }
            } else {
                dFrom = dateFrom;
            }

            dispatch(thirdPaymentActions.setFiltersBack(valuesFiltersBack));

            dispatch(
                thirdPaymentActions.loadListThirdRequest({
                    dateFrom: dFrom,
                    dateTo: enableRangeDatefield ? dates[1] : dateTo,
                    amountFrom,
                    amountTo,
                    status,
                    typePayment: typeL,
                    latestPageNumber: "1",
                    latestTotalPages: "1",
                }),
            );
        },
    }),
    resizableRoute,
)(PayThirdPartiesList);
